import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userName: localStorage.getItem("userName") || "",
    roleName: localStorage.getItem("roleName") || "",
    sessionid: localStorage.getItem("sessionid") || "",
  },
  mutations: {
    SET_USER_INFO(state, info) {
      state.userName = info.user;
      state.roleName = info.role;
      state.sessionid = info.sessionid;
      localStorage.setItem("sessionid", info.sessionid);
      localStorage.setItem("userName", info.user);
      localStorage.setItem("roleName", info.role);
    },
    CLEAR_USER_INFO(state) {
      state.userName = "";
      state.roleName = "";
      state.sessionid = "";
      localStorage.removeItem("sessionid");
      localStorage.removeItem("userName");
      localStorage.removeItem("roleName");
    },
  },
  actions: {
    setUserInfo({ commit }, info) {
      commit("SET_USER_INFO", info);
    },
    logout({ commit }) {
      commit("CLEAR_USER_INFO");
    },
  },
});
